import { FC } from 'react';
import Modal from '@components/Modal';
import s from '@modals/ModalsCommon.module.scss';
import Button from '@/components/DesignLibrary/Button';

type Props = {
  onClose: () => void;
  onUpload: () => void;
};

const PaystubModal: FC<Props> = ({ onClose, onUpload }) => (
  <Modal hideBottomInset title="Upload Paystubs" onClose={onClose}>
    <div className={s.container} style={{ textAlign: 'center' }}>
      <h1 className="heading-sm">Please upload each paystub as an individual file.</h1>
      <p className='body-sm'>
        <strong>Do not combine paystubs into a single file.</strong>
        You can upload multiple files at once—just make sure each file contains only one paystub.
      </p>
      <Button variant="primary" size="md" onClick={onUpload}>
        Upload Paystubs
      </Button>
    </div>
  </Modal>
);

export default PaystubModal;
